import {combineReducers} from 'redux'
import purchaseOrders from './purchaseOrders'
import selected from './selected'
import selector from './selector'
import itemDrawer from './itemDrawer'
import selectedPurchaseInvoice from './selectedPurchaseInvoice'

export default combineReducers({
  purchaseOrders,
  selected,
  selector,
  itemDrawer,
  selectedPurchaseInvoice,
})
